module.exports = __webpack_public_path__ + "static/media/damnjoan.27989607.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/damnjoan.png
 ** module id = 288
 ** module chunks = 0
 **/